import React from 'react';
import { TextInput, StyleSheet, Platform, View, Pressable, Text, TextStyle, ViewStyle, StyleProp } from 'react-native';
import { COLORS, APP_CONSTANTS } from '@/constants/residents';
import { strings } from '@/constants/residents/strings';
import { SVG_COMPONENTS } from '@/assets/admin';

type Props = {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
  showPassword: boolean;
  toggleShowPassword: () => void;
  inputRef?: React.RefObject<TextInput | null>;
  onSubmitEditing?: () => void;
  style?: StyleProp<TextStyle | ViewStyle>;
};

export const PasswordInput: React.FC<Props> = ({
  value,
  onChangeText,
  placeholder = strings.login.field.passwordPlaceholder,
  showPassword,
  toggleShowPassword,
  inputRef,
  onSubmitEditing,
  style,
}) => {
  return (
    <View style={styles.container}>
      <TextInput
        ref={inputRef}
        style={[styles.input, styles.passwordInput, style as any]}
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        placeholderTextColor={COLORS.TEXT_SECONDARY}
        secureTextEntry={!showPassword}
        autoCapitalize="none"
        textContentType="password"
        onSubmitEditing={onSubmitEditing}
      />
            <Pressable style={styles.eyeButton} onPress={toggleShowPassword}>
              {showPassword ? (
                <SVG_COMPONENTS.EYE_OPEN width={24} height={24} color="#6B7280" />
              ) : (
                <SVG_COMPONENTS.EYE_CLOSED width={24} height={24} color="#6B7280" />
              )}
            </Pressable>
      {/* <Pressable style={styles.eyeButton} onPress={toggleShowPassword}>
        <Text style={styles.eyeText}>{showPassword ? '👁' : '👁‍🗨'}</Text>
      </Pressable> */}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
  },
  input: {
    height: APP_CONSTANTS.TEXT_FIELD_HEIGHT,
    borderWidth: 1,
    borderColor: COLORS.SECONDARY,
    borderRadius: APP_CONSTANTS.BUTTON_CORNER_RADIUS,
    paddingHorizontal: 16,
    fontSize: APP_CONSTANTS.INPUT_FONT_SIZE,
    color: COLORS.TEXT_PRIMARY,
    backgroundColor: COLORS.SECONDARY,
    fontFamily: Platform.select({
      ios: 'Avenir-Book',
      android: 'sans-serif',
      default: 'System',
    }),
  },
  passwordInput: {
    paddingRight: 50,
    width: '100%',
  },
  eyeButton: {
    position: 'absolute',
    right: 16,
    top: 0,
    height: APP_CONSTANTS.TEXT_FIELD_HEIGHT,
    justifyContent: 'center',
  },
  eyeText: {
    fontSize: 20,
  },
});


